import { gql } from '@apollo/client'

export default gql`
  query GetFavoriteFilters($type: FavoriteSearchType!) {
    getNFTFavoriteFilters(favoriteSearchType: $type) {
      ID
      name
      filterOption
      sortOption
    }
  }
`
